import Api from "../utils/api";
import { push } from "react-router-redux";

export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";

export function signIn(email, password) {
  return function(dispatch) {
    dispatch(authStart());
    return Api.authenticate(email, password)
      .then(data => {
        dispatch(authSuccess(data))
      })
      .catch(error => {
        dispatch(authError(error.message));
      });
  };
}

export function signOut() {
  return function(dispatch) {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("phoneCountry");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_firstname");
    localStorage.removeItem("user_lastname");
    localStorage.removeItem("auth_expires");
    localStorage.removeItem("planTier");
    localStorage.removeItem("visited_recommendations");

    if (localStorage.getItem("auth_token")) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_firstname");
      localStorage.removeItem("user_lastname");

      // localStorage.removeItem("recommendations_cart_fetched_with_prod");
      // localStorage.removeItem("cart-products-ids");

    }
    if (localStorage.getItem("first_time_purchase"))
      localStorage.removeItem("first_time_purchase");
    if (localStorage.getItem("has_purchased"))
      localStorage.removeItem("has_purchased");

    //Remove No Hair Profile Tag
    if (localStorage.getItem("user_has_hair_profile"))
      localStorage.removeItem("user_has_hair_profile");

    //Remove No Hair Profile Tag
    if (localStorage.getItem("user_has_skin_profile"))
      localStorage.removeItem("user_has_skin_profile");

    //Remove ATH
    if (localStorage.getItem("ath_auth_token")) {
      localStorage.removeItem("ath_auth_token");
      localStorage.removeItem("ath_user_id");
      localStorage.removeItem("ath_user_firstname");
      localStorage.removeItem("ath_user_lastname");
    }
    
    localStorage.removeItem("planTier");
    localStorage.removeItem("visited_recommendations");
    localStorage.removeItem("visited_scheduleConsult");
    localStorage.removeItem("user_account_info");
    localStorage.removeItem("gateFeePaid");
    localStorage.removeItem("doneQuizStepId");
    localStorage.removeItem("email");
    localStorage.removeItem("phone_number");
    localStorage.removeItem("estheticianNote");
    localStorage.removeItem("budget");
    localStorage.removeItem("recommendations_fetched");

    Object.keys(localStorage).forEach(item => {
      if (item.includes("reco")) localStorage.removeItem(item);
      if (item.includes("_global_")) localStorage.removeItem(item);
      if (item.includes("SQ_")) localStorage.removeItem(item);
    });


    dispatch(authLogout());
    window.location.pathname.includes("/ath")
      ? setTimeout(() => {
          window.location.href = process.env.REACT_APP_UL_ATH_BUFFER_PAGE;
        }, 1)
      : dispatch(push("/"));
  };
}

function authStart() {
  return {
    type: AUTH_START
  };
}

function authSuccess(data) {
  return {
    type: AUTH_SUCCESS,
    payload: data
  };
}

function authError(message) {
  return {
    type: AUTH_ERROR,
    payload: message
  };
}

function authLogout() {
  return {
    type: AUTH_LOGOUT
  };
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js